jQuery(function($) {
	let $parent = $('.npbm_files_bulk_add');
});